import { render, staticRenderFns } from "./GlobalBulkCompleteNotification.vue?vue&type=template&id=4408b7b0&scoped=true&"
import script from "./GlobalBulkCompleteNotification.vue?vue&type=script&lang=js&"
export * from "./GlobalBulkCompleteNotification.vue?vue&type=script&lang=js&"
import style0 from "./GlobalBulkCompleteNotification.vue?vue&type=style&index=0&id=4408b7b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408b7b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
